/**
 * Bot döngüsü (GorevYoneticisi.taskInterval) ne zaman kurulmalı.
 *
 * Döngü, UYAP bağlantısı SAĞLANDIĞI anda ve henüz kurulu değilse kurulur.
 * Bağlantı düşünce döngü durdurulmaz: dongu() zaten bağlantısızken sormaz ve
 * 'oto' modda yeniden bağlanmayı kendisi dener (GorevYoneticisi.ts).
 *
 * Saf tutuldu ki bileşen mount etmeden test edilebilsin (repo deseni).
 */
export function botDongusuKurulmaliMi(uyapBagli: boolean, mevcutHandle: unknown): boolean {
    return uyapBagli === true && (mevcutHandle === null || mevcutHandle === undefined);
}
